<template>
    <div>
        <div id="hero-banner">
            <div class="bg-parallax banner-image" data-inverted="true" data-speed="0.1" :style="bannerStyle"></div>
            <div class="overlay text-center">
                <h1 id="hero-text">FAQS</h1>
            </div>
        </div>

        <div>
            <div class="container pt-6 pb-8">
                <h2 class="text-default display-4 montserrat-bold text-uppercase mb-5">
                    <span class="text-danger inline">Cutiefy</span> frequently Asked Questions
                </h2>
                <h4>
                    Thank you for your interest in knowing more about the Cutiefy Mobile App. Here are answers to frequently asked questions on how to use the app.
                    If you have more questions or comments, please feel free to use the inquiry form below.
                </h4>
                <div class="accordion mt-6" id="faqs-accordion">
                    <div class="card">
                        <div class="card-header" id="question-1-heading">
                            <a href="#" type="button" class="btn btn-link mb-0" data-toggle="collapse" data-target="#question-1" aria-expanded="false" aria-controls="question-1">
                                Can I select my preferred service provider?
                                <i class="fas fa-angle-down rotate-icon"></i>
                            </a>
                        </div>
                        <div id="question-1" class="collapse" aria-labelledby="question-1-heading" data-parent="#faqs-accordion">
                            <div class="card-body">
                                Yes. Cutiefy App will display the list of available Cutiefy Accredited Service Providers near your desired location and according to your chosen date, time, and service.
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header" id="question-2-heading">
                            <a href="#" type="button" class="btn btn-link mb-0" data-toggle="collapse" data-target="#question-2" aria-expanded="false" aria-controls="question-2">
                                Can I select the beauty expert who will perform the service I requested?
                                <i class="fas fa-angle-down rotate-icon"></i>
                            </a>
                        </div>
                        <div id="question-2" class="collapse" aria-labelledby="question-2-heading" data-parent="#faqs-accordion">
                            <div class="card-body">
                                Yes. Cutiefy App will display the names of the beauty experts for each type of service requested who are available during your preferred date and time of appointment.
                                You can also tap “view calendar” to see the availability of a particular expert you prefer to perform the service in case he/she is not listed on the date and time you chose.
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header" id="question-3-heading">
                            <a href="#" type="button" class="btn btn-link mb-0" data-toggle="collapse" data-target="#question-3" aria-expanded="false" aria-controls="question-3">
                                Can I cancel my booking?
                                <i class="fas fa-angle-down rotate-icon"></i>
                            </a>
                        </div>
                        <div id="question-3" class="collapse" aria-labelledby="question-3-heading" data-parent="#faqs-accordion">
                            <div class="card-body">
                                Yes. You can cancel your booking immediately or one (1) hour before the appointment time, at the latest, to avoid being charged penalty fee, booking fee, and applicable transaction
                                charges (if any).  Also, your account will be disabled if cancellations and no-shows are done for three consecutive times.
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header" id="question-4-heading">
                            <a href="#" type="button" class="btn btn-link mb-0" data-toggle="collapse" data-target="#question-4" aria-expanded="false" aria-controls="question-4">
                                How can I get a refund for my cancelled booking?
                                <i class="fas fa-angle-down rotate-icon"></i>
                            </a>
                        </div>
                        <div id="question-4" class="collapse" aria-labelledby="question-4-heading" data-parent="#faqs-accordion">
                            <div class="card-body">
                                If credit card, debit card, or any other electronic payment provider was used to pay for the booking, the transaction fees/charges (if any) and booking fee may not be refunded.
                                Penalty fee, if applicable, will also be deducted from the amount to be refunded.  All refunds shall be made via the original payment mechanism and to the person who made the original
                                payment depending on the process and timelines of payment partners.  Refunds can also be made in the form of Customer Credits in the Cutiefy Platform.
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header" id="question-5-heading">
                            <a href="#" type="button" class="btn btn-link mb-0" data-toggle="collapse" data-target="#question-5" aria-expanded="false" aria-controls="question-5">
                                What payment options are available?
                                <i class="fas fa-angle-down rotate-icon"></i>
                            </a>
                        </div>
                        <div id="question-5" class="collapse" aria-labelledby="question-5-heading" data-parent="#faqs-accordion">
                            <div class="card-body">
                                Cutiefy mobile app accepts credit or debit card payments through Paypal.Payments via Gcash are also accepted. Cash payments shall be made directly to the service provider.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { resource } from "@utils/network";
export default {
    name: "FaqsPage",
    computed: {
        bannerStyle() {
            return `background-image:url('${ resource("images/faqs-banner.jpg") }')`;
        }
    },
}
</script>

<style scoped lang="css">
    #hero-banner {
        position: relative;
        height: 800px;
        overflow: hidden;
    }
    #hero-banner .banner-image {
        height: 100%;
    }
    #hero-text {
        margin-top: 400px;
        font-family: 'Montserrat', sans-serif;
        color: white;
        text-transform: uppercase;
        font-size: 3.8rem;
        font-weight: 800;
        line-height: 1.5;
    }
    #hero-banner .overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.6);
        top: 0px;
    }
    .company-banner {
        width: 100%;
    }
    .accordion .card-header .btn {
        display: block;
        text-align: left;
        color: #32325d !important;
        font-size: 1rem;
    }
    .accordion .card-header .btn .fa-angle-down {
        float: right;
        margin: 3px;
        transform: rotate(180deg);
        transition: transform .3s ease-in-out;
    }
    .accordion .card-header .btn[aria-expanded="false"] .fa-angle-down {
        transform: rotate(0deg);
    }
    .accordion .card-body {
        padding: 1.5rem 4.5rem 2.5rem ;
    }
    .accordion .card,
    .accordion .card-header,
    .accordion .card-body {
        border-color:rgba(0, 0, 0, 0.1) !important;
    }
</style>